/**
 * API do fluxo BPe (passagens rodoviárias) no Chat.
 * Todas as rotas exigem permissão bpe.view e header Company.
 */

import { fetchData } from "./client";

/**
 * Lista cidades para origem ou destino.
 * @param {string} tipo - "origem" | "destino"
 * @param {number|null} origemId - para tipo=destino, id da cidade de origem para filtrar destinos
 */
export async function getBpeCidades(tipo = "origem", origemId = null) {
  const params = new URLSearchParams({ tipo });
  if (tipo === "destino" && origemId) params.set("origem_id", origemId);
  const res = await fetchData(`/bpe/cidades?${params.toString()}`, "GET");
  return res?.data ?? res ?? [];
}

/**
 * Lista passagens (BPs) já emitidas na conversa.
 */
export async function getBpeList(conversationId) {
  const res = await fetchData(`/conversations/${conversationId}/bpe`, "GET");
  return res?.data ?? res ?? [];
}

/**
 * Consulta viagens disponíveis (origem, destino, data).
 * Body: { origem, destino, data_viagem, quantidade_passageiros?, id_formadepagamento? }
 * origem/destino podem ser postback string (##CIDADE##...) ou objeto { id, id_interno, nome, ... }
 */
export async function consultarViagens(conversationId, body) {
  const res = await fetchData(
    `/conversations/${conversationId}/bpe/consultar-viagens`,
    "POST",
    body
  );
  const data = res?.data ?? res;
  if (data?.error) throw new Error(data.error);
  return data;
}

/**
 * Obtém mapa de assentos para a viagem selecionada.
 * Body: { opcao_viagem } (1-based)
 */
export async function getAssentos(conversationId, opcaoViagem) {
  const res = await fetchData(`/conversations/${conversationId}/bpe/assentos`, "POST", {
    opcao_viagem: opcaoViagem,
  });
  const data = res?.data ?? res;
  if (data?.error) throw new Error(data.error);
  return data;
}

/**
 * Pré-reserva uma poltrona (bloqueio).
 * Body: { poltrona, nome, documento, email?, celular?, index? }
 */
export async function preReserva(conversationId, body) {
  const res = await fetchData(`/conversations/${conversationId}/bpe/pre-reserva`, "POST", body);
  const data = res?.data ?? res;
  if (data?.error) throw new Error(data.error);
  return data;
}

/**
 * Confirma reserva e emite BPe.
 * Body: { passageiro_index?, nome?, documento?, email?, celular?, cidade?, cep?, endereco? }
 */
export async function confirmarReserva(conversationId, body) {
  const res = await fetchData(`/conversations/${conversationId}/bpe/reserva`, "POST", body);
  const data = res?.data ?? res;
  if (data?.error) throw new Error(data.error);
  return data;
}
